<template>
  <div class="yx-place-page main-layout">
    <el-card class="box-table box-inner" shadow="never">
      <c-table
        :data="pageData"
        :tableColumns="tableColumns"
        :pagination="pageParams"
        @change="pageGet"
        :index="true"
        v-loading="pageLoading"
      >
        <template slot="custom" slot-scope="scope">
          <i
            class="el-icon-location location-icon"
            @click="handleLocation(scope.row)"
          ></i>
          <!-- <el-button
            type="primary"
            class="leave-btn"
            @click="handleLocation(scope.row.id, 'detail')"
            >详情</el-button
          > -->
        </template>
      </c-table>
    </el-card>
    <!-- 编辑弹框 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      @close="handleDialogClose"
    >
      <div id="map" class="map-container"></div>
      <!-- <c-grid v-model="handleData" :gridItems="formItems" bord></c-grid> -->
    </el-dialog>
  </div>
</template>

<script>
import MapLoader from "@/libs/AMap.js";
import MPage from "@/mixins/MPage.js";
import MHandle from "@/mixins/MHandle.js";
import Configs from "./data/mustSee";
let mPage = MPage({
  pagePath: "/welcome-live/location/listPage",
  pageDelPath: "",
  pageDelsPath: "",
  pageParams: {},
});
let mHandle = MHandle({
  handleGetPath: "",
  handleInsertPath: "",
  handleUpdatePath: "",
  handleDownLoadPath: "",
  handleData: {
    id: "",
  },
});
export default {
  mixins: [mPage, mHandle],
  data() {
    let { searchItems, tableColumns, formItems, formRules } = Configs(this);
    return {
      isFold: false,
      searchItems,
      tableColumns,
      formItems,
      formRules: {},
      idList: [],
      title: "",
      dialogFormVisible: false,
      pageData: [
        {
          id: 1,
          11: "测试名称",
          22: "",
          33: "诚毅学院",
          44: "",
          55: "张三",
          66: "13号实验楼",
        },
      ],
    };
  },
  created() {
    this.map = null;
  },
  beforeMount() {
    MapLoader();
  },
  mounted() {},
  methods: {
    goto(id, type) {
      this.dialogFormVisible = true;
      if (id) {
        if (type == "edit") {
          this.title = "编辑点位信息";
        } else {
          this.title = "点位信息详情";
        }
      } else {
        this.title = "新增点位信息";
      }
    },
    refresh() {
      this.pageParams = {};
      this.pageGet(true);
    },
    tableColumnsChange(data) {
      let self = this;
      self.tableColumns.forEach((item) => {
        if (data.indexOf(item.prop) == -1) {
          item.show = false;
        } else {
          item.show = true;
        }
      });
    },
    pageGetAfterFn(data) {
      data.records.forEach((item) => {
        item.sex = item.sex == 0 ? "男" : "女";
      });
      return data;
    },
    handleDialogClose() {
      this.dialogFormVisible = false;
    },
    handleLocation(item) {
      this.dialogFormVisible = true;
      this.title = "具体位置";
      this.$nextTick(() => {
        this.mapInit(item.lng, item.lat);
      });
    },
    // 地图初始化
    mapInit(lng, lat) {
      let map = new AMap.Map("map", {
        zoom: 18,
        // center: [110,24.590791],
        pitch: 60,
      });
      AMap.plugin(["AMap.ToolBar"], function () {
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        map.addControl(
          new AMap.ToolBar({
            // 简易缩放模式，默认为 false
            liteStyle: true,
            position: "LB",
          })
        );
      });
      map.setCenter([lng, lat]);
      var marker = new AMap.Marker({
        position: [lng, lat],
        map,
      });

      this.map = map;
    },
  },
};
</script>

